import { useEffect, useState } from "react";

export const useDisplayView = () => {
  // inicializar desde la URL
  const getInitialView = () => {
    try {
      const p = new URLSearchParams(window.location.search);
      const v = (p.get("view") || "hero").toLowerCase();
      const allowed = ["hero", "podium", "standings", "login", "diagram"];
      return allowed.includes(v) ? v : "hero";
    } catch {
      return "hero";
    }
  };

  const [view, setView] = useState(getInitialView);

  useEffect(() => {
    const syncFromURL = () => {
      try {
        const p = new URLSearchParams(window.location.search);
        const v = (p.get("view") || "hero").toLowerCase();
        const allowed = ["hero", "podium", "standings", "login", "diagram"];
        if (allowed.includes(v)) setView(v);
      } catch { }
    };
    window.addEventListener("popstate", syncFromURL);
    return () => window.removeEventListener("popstate", syncFromURL);
  }, []);

  const go = (v) => {
    const url = new URL(window.location.href);
    if (v === "all") url.searchParams.delete("view");
    else url.searchParams.set("view", v);
    window.history.replaceState({}, "", url.toString());
    setView(v);
  };

  return { view, go };
};
